export const PAGES_SOLUTIONS_MESSAGE_WHATSAPP_TEMPLATE = {
  QUINDE: 'https://quindefee.com/',
  NUNA: 'Hola%20quiero%20más%20información%20sobre%20Nuna',
  MIQO: 'Hola%20quiero%20más%20información%20sobre%20Miqo',
  ALPAQQA: 'Hola%20quiero%20más%20información%20sobre%20Alpaqqa',
  QREATIVEE: 'Hola%20quiero%20más%20información%20sobre%20Qreativee',
  DEMONSTRATION: 'Hola%20quiero%20agendar%20una%20demostración%20',
}
